/* eslint-disable no-unused-vars */
import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { isPurchaseTab, resetUserForm, validateEmailSelector } from 'src/features'
import { CustomCol, FormLabels, CustomTextInput, CustomTag } from 'src/components'

interface SellerUserAcquisitionProps {
  handleEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  setIsUserRegisterModalVisible: (value: boolean) => void
  isUserEmailInvalid: boolean
  errorEmailValidation: string
}

const SellerUserAcquisition: React.FC<SellerUserAcquisitionProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { loading: loadingValidateEmail, success: successEmailValidation } = useAppSelector(validateEmailSelector)

  const isPurchaseTabValue = useAppSelector(isPurchaseTab)

  let emailTag = null
  if (loadingValidateEmail) {
    emailTag = <CustomTag type='processing' text={t('admin.Brokerage.EmailMessages.ValidateEmail')} />
  } else if (props.isUserEmailInvalid) {
    emailTag = <CustomTag type='error' text={t(`admin.Brokerage.EmailMessages.${props.errorEmailValidation}`)} />
  } else if (successEmailValidation) {
    emailTag = <CustomTag type='success' text={t('admin.Brokerage.EmailMessages.SUCCESS')} />
  }

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.SellerEmail')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomTextInput
        name={'sellerEmail'}
        onChange={props.handleEmailChange}
        placeholder={t('admin.Brokerage.EmailPlaceHolder')}
        handleToggleClick={() => {
          dispatch(resetUserForm())
          props.setIsUserRegisterModalVisible(true)
        }}
        toogleText={t('admin.Brokerage.CreateUser')}
        type='email'
        required
      />
      {isPurchaseTabValue && emailTag}
    </CustomCol>
  </Row>
}

export default SellerUserAcquisition
